module.exports = __webpack_public_path__ + "dc1df34e6e7424a75f554ebd1fa24f51.svg";